/**
 * 将 HTTP 图片 URL 转换为 HTTPS
 * @param url 输入的 URL
 * @returns 如果是 HTTP 图片 URL 则返回转换后的 HTTPS URL，否则返回原 URL
 */
export function convertToHttps(url) {
    // 检查 URL 是否为空或不是字符串类型
    if (!url || typeof url !== 'string') {
        return url;
    }
    // 检查 URL 是否以 "http://" 开头
    if (url.indexOf('http://') !== 0) {
        return url;
    }
    // 提取域名后的路径
    const path = url.slice(7); // 7 是 "http://".length
    // 检查是否为图片 URL
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
    const isImage = imageExtensions.some(ext => path.toLowerCase().indexOf(ext) > -1);
    if (isImage) {
        return 'https://' + path + '@750w';
    }
    return url;
}
export function getImage(uri) {
    return {
        uri: convertToHttps(uri)
    };
}
export const photos = {
    button_bg: 'https://p0.meituan.net/travelcube/5d2dd4ec676863cdb666939f78eb1b1321616.png'
};
